module.exports = (__parcel__import__("gotB2")).then(() => parcelRequire('fyWP3'));